import { render, staticRenderFns } from "./CreateShareholder.vue?vue&type=template&id=33bf36c9&scoped=true"
import script from "./CreateShareholder.vue?vue&type=script&lang=js"
export * from "./CreateShareholder.vue?vue&type=script&lang=js"
import style0 from "./CreateShareholder.vue?vue&type=style&index=0&id=33bf36c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bf36c9",
  null
  
)

export default component.exports